<!--
 * @Author: zl
 * @Date: 2022-11-10 10:45:37
 * @LastEditTime: 2022-11-14 17:11:21
 * @LastEditors: zl
 * @Description: 标签管理 --- 标签汇总
-->
<template>
	<!-- 主页面 -->
	<div class="operation-layout"
		 v-if="!routeQuery.type">
		<!-- 搜索条件区域 -->
		<div class="filter-box"
			 v-if="searchToggle">
			<el-form :model="searchForm"
					 label-width="80px"
					 ref="searchForm"
					 size="small">
				<el-row>
					<el-col :span="6">
						<el-form-item label="业务板块"
									  prop="value">
							<el-select v-model="searchForm.value"
									   placeholder="请选择">
								<el-option v-for="(item, index) in businessList"
										   :key="'value' + index"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label-width="20px">
							<el-button type="primary"
									   @click="doSearch">搜索</el-button>
							<el-button type="warning"
									   @click="doRefresh">重置</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<!-- 表格区域 -->
		<div class="operation-main">
			<div class="operation-header overflow-hidden">
				<div class="title">
					合计标签<span class="blue"> {{tableObj.total}}</span> 个
				</div>
				<div class="btnGroups">
					<el-button type="warning"
							   icon="el-icon-setting"
							   size="small"
							   @click="searchToggle = !searchToggle"></el-button>
				</div>
			</div>
			<div class="operation-container w-table-layout w-table-page">
				<div class="w-table-content"
					 v-show="tableShow">
					<vxe-table align="center"
							   auto-resize
							   border
							   :data="tableObj.tableData"
							   :loading="tableObj.loading"
							   height="100%"
							   highlight-hover-row
							   highlight-current-row
							   resizable
							   size="small"
							   show-overflow="tooltip"
							   show-header-overflow="tooltip">
						<vxe-column type="seq"
									title="序号"
									width="70px"></vxe-column>
						<vxe-column field="valueName"
									title="业务板块"
									min-width="185"></vxe-column>
						<vxe-column field="platformCountsName"
									title="平台标签数量"
									header-align="center"
									align="right"></vxe-column>
						<vxe-column field="privateCountsName"
									title="个人标签数量"
									header-align="center"
									align="right"></vxe-column>
						<vxe-column field="typeCountsName"
									title="标签标注记录数量"
									header-align="center"
									align="right"></vxe-column>
						<vxe-column field="objectCountsName"
									title="标签标注数量"
									header-align="center"
									align="right"></vxe-column>
						<vxe-column title="操作"
									width="120px">
							<template v-slot="{ row }">
								<el-button type="text"
										   size="mini"
										   title="详情"
										   v-if="roleBtns.includes('detail')"
										   icon="el-icon-zoom-in"
										   @click="doView(row)"></el-button>
							</template>
						</vxe-column>
					</vxe-table>
				</div>
				<div class="w-table-footer">
					<el-pagination @size-change="handleSizeChange"
								   @current-change="handleCurrentChange"
								   :current-page="tableObj.currentPage"
								   :page-size="tableObj.pageSize"
								   :page-sizes="[10, 20, 50, 100]"
								   layout="total, sizes, prev, pager, next, jumper"
								   :total="tableObj.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>

	<!-- 详细页面 -->
	<summary-detail v-else
					:allList="tableObj.tableData"></summary-detail>
</template>

<script>
import { mapState } from 'vuex'
import * as API from '@/api/modules/tag_management'
import summaryDetail from '@/views/system-management/tag/components/tag_summary_detail'
export default {
	components: {
		summaryDetail,
	},
	data() {
		return {
			searchToggle: true, // 切换展示 筛选条件
			tableShow: true, // 展示表格
			// 查询条件
			searchForm: {
				value: '', // 业务板块
			},
			// 表格参数
			tableObj: {
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				loading: false,
			},
			// 码表数组
			businessList: [], // 业务板块
		}
	},
	created() {
		// 获取码表
		this.getDictList()
		// 获取表格数据
		this.getTableData()
	},
	methods: {
		/**
		 * @description: 准备工作
		 */
		// 获取码表
		getDictList() {
			API.selectSysDictByParent({ value: '1056' }).then((res) => {
				this.businessList = res.data
			})
		},

		// 获取表格数据
		getTableData() {
			let params = this.$utils.clone(this.searchForm, true)
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			this.tableObj.loading = true
			API.getAllTag(params)
				.then((res) => {
					this.tableObj.loading = false
					this.tableObj.tableData = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		/**
		 * @description: 搜索区域
		 */

		// 点击查询
		doSearch() {
			this.tableObj.currentPage = 1
			this.getTableData()
		},

		// 点击刷新、重置
		doRefresh() {
			this.$refs.searchForm.resetFields()
			this.doSearch()
		},

		/**
		 * @description: 表格相关
		 */

		// 点击查看
		doView(row) {
			let { id, value, applys } = row
			this.$router.push({
				query: {
					type: 'detail',
					rowId: id,
					value,
					applys,
				},
			})
		},

		// 表格 每页条数切换
		handleSizeChange(pageSize) {
			this.tableObj.pageSize = pageSize
			this.getTableData()
		},

		// 表格 页码切换
		handleCurrentChange(currentPage) {
			this.tableObj.currentPage = currentPage
			this.getTableData()
		},
	},
	computed: {
		// 路由参数
		routeQuery() {
			return this.$route.query
		},

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},
	},
}
</script>

<style scoped lang="less">
</style>